exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GirisSayfa{display:flex;flex-direction:column;min-height:100vh;background-color:#4285f4}.GirisForm{text-align:center;border-top-left-radius:6px;border-top-right-radius:6px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;box-shadow:0 4px 8px rgb(0 0 0/17%);background-color:#fbfbfb;padding:20px}.GirisCont{margin:auto;align-self:flex-start;width:100%}.girislogo{width:60%;margin:20px 0}.mudulogo{margin-top:50px;position:relative;display:block}.mudulogo img{width:40%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15b287f8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Kayit/Index.vue
// module id = 150
// module chunks = 0